export interface FontPairing {
  id: string
  numericId?: number
  displayFont: string
  bodyFont: string
  name?: string
  favoritesCount?: number
}

export interface PairingCategory {
  id: string
  name: string
  description: string
  emoji: string
  pairings: FontPairing[]
}

export const PAIRING_CATEGORIES: PairingCategory[] = [
  {
    id: 'spooky',
    name: 'Spooky',
    description: 'Horror, Halloween, dark themes',
    emoji: '👻',
    pairings: [
      { id: 'spooky-1', displayFont: 'Creepster', bodyFont: 'Crimson Pro', name: 'Haunted Tales' },
      { id: 'spooky-2', displayFont: 'Nosifer', bodyFont: 'Lora', name: 'Blood Moon' },
      { id: 'spooky-3', displayFont: 'Butcherman', bodyFont: 'EB Garamond', name: 'Gothic Horror' },
      { id: 'spooky-4', displayFont: 'Eater', bodyFont: 'Merriweather', name: 'Nightmare Fuel' },
      { id: 'spooky-5', displayFont: 'Metal Mania', bodyFont: 'Source Serif 4', name: 'Dark Metal' },
    ]
  },
  {
    id: 'elegant-wedding',
    name: 'Elegant Wedding',
    description: 'Romantic, formal invitations',
    emoji: '💒',
    pairings: [
      { id: 'wedding-1', displayFont: 'Great Vibes', bodyFont: 'Cormorant Garamond', name: 'Forever Yours' },
      { id: 'wedding-2', displayFont: 'Pinyon Script', bodyFont: 'EB Garamond', name: 'Classic Romance' },
      { id: 'wedding-3', displayFont: 'Alex Brush', bodyFont: 'Libre Baskerville', name: 'Garden Party' },
      { id: 'wedding-4', displayFont: 'Tangerine', bodyFont: 'Cormorant', name: 'Timeless Love' },
      { id: 'wedding-5', displayFont: 'Sacramento', bodyFont: 'Crimson Pro', name: 'Sunset Vows' },
    ]
  },
  {
    id: 'tech-startup',
    name: 'Tech Startup',
    description: 'Modern, clean, SaaS products',
    emoji: '🚀',
    pairings: [
      { id: 'tech-1', displayFont: 'Space Grotesk', bodyFont: 'Inter', name: 'Launch Day' },
      { id: 'tech-2', displayFont: 'Sora', bodyFont: 'DM Sans', name: 'Unicorn Dreams' },
      { id: 'tech-3', displayFont: 'Outfit', bodyFont: 'Plus Jakarta Sans', name: 'Scale Up' },
      { id: 'tech-4', displayFont: 'Lexend', bodyFont: 'Work Sans', name: 'Growth Mode' },
      { id: 'tech-5', displayFont: 'Manrope', bodyFont: 'Nunito Sans', name: 'Series A' },
    ]
  },
  {
    id: 'editorial-magazine',
    name: 'Editorial Magazine',
    description: 'Sophisticated publishing',
    emoji: '📰',
    pairings: [
      { id: 'editorial-1', displayFont: 'Playfair Display', bodyFont: 'Source Serif 4', name: 'The Sunday Read' },
      { id: 'editorial-2', displayFont: 'Bodoni Moda', bodyFont: 'Libre Baskerville', name: 'Vogue Style' },
      { id: 'editorial-3', displayFont: 'DM Serif Display', bodyFont: 'Lora', name: 'Long Form' },
      { id: 'editorial-4', displayFont: 'Cormorant Garamond', bodyFont: 'PT Serif', name: 'Literary Review' },
      { id: 'editorial-5', displayFont: 'Fraunces', bodyFont: 'Newsreader', name: 'Feature Story' },
    ]
  },
  {
    id: 'retro-70s',
    name: 'Retro 70s',
    description: 'Groovy, vintage vibes',
    emoji: '🕺',
    pairings: [
      { id: 'retro-1', displayFont: 'Righteous', bodyFont: 'Josefin Sans', name: 'Disco Fever' },
      { id: 'retro-2', displayFont: 'Boogaloo', bodyFont: 'Quicksand', name: 'Funky Town' },
      { id: 'retro-3', displayFont: 'Fascinate', bodyFont: 'Nunito', name: 'Groovy Baby' },
      { id: 'retro-4', displayFont: 'Monoton', bodyFont: 'Poppins', name: 'Neon Nights' },
      { id: 'retro-5', displayFont: 'Rubik Moonrocks', bodyFont: 'Rubik', name: 'Space Odyssey' },
    ]
  },
  {
    id: 'cyberpunk',
    name: 'Cyberpunk',
    description: 'Futuristic, neon, dystopian',
    emoji: '🤖',
    pairings: [
      { id: 'cyber-1', displayFont: 'Orbitron', bodyFont: 'Exo 2', name: 'Neo Tokyo' },
      { id: 'cyber-2', displayFont: 'Audiowide', bodyFont: 'Rajdhani', name: 'Circuit City' },
      { id: 'cyber-3', displayFont: 'Michroma', bodyFont: 'Titillium Web', name: 'Chrome Dreams' },
      { id: 'cyber-4', displayFont: 'Oxanium', bodyFont: 'Barlow', name: 'Data Stream' },
      { id: 'cyber-5', displayFont: 'Electrolize', bodyFont: 'Share Tech', name: 'Blade Runner' },
    ]
  },
  {
    id: 'childrens-book',
    name: "Children's Book",
    description: 'Playful, friendly, educational',
    emoji: '🧸',
    pairings: [
      { id: 'kids-1', displayFont: 'Fredoka', bodyFont: 'Nunito', name: 'Storytime' },
      { id: 'kids-2', displayFont: 'Baloo 2', bodyFont: 'Comic Neue', name: 'Silly Goose' },
      { id: 'kids-3', displayFont: 'Bubblegum Sans', bodyFont: 'Varela Round', name: 'Bubble Pop' },
      { id: 'kids-4', displayFont: 'Chewy', bodyFont: 'Quicksand', name: 'Adventure Time' },
      { id: 'kids-5', displayFont: 'Sniglet', bodyFont: 'ABeeZee', name: 'ABC Fun' },
    ]
  },
  {
    id: 'luxury-brand',
    name: 'Luxury Brand',
    description: 'High-end, premium feel',
    emoji: '💎',
    pairings: [
      { id: 'luxury-1', displayFont: 'Cormorant Garamond', bodyFont: 'Montserrat', name: 'Fifth Avenue' },
      { id: 'luxury-2', displayFont: 'Cinzel', bodyFont: 'Raleway', name: 'Black Tie' },
      { id: 'luxury-3', displayFont: 'Libre Bodoni', bodyFont: 'Lato', name: 'Haute Couture' },
      { id: 'luxury-4', displayFont: 'Tenor Sans', bodyFont: 'Questrial', name: 'Minimalist Chic' },
      { id: 'luxury-5', displayFont: 'Marcellus', bodyFont: 'Poppins', name: 'Gallery Opening' },
    ]
  },
  {
    id: 'minimalist',
    name: 'Minimalist',
    description: 'Clean, zen, whitespace',
    emoji: '⬜',
    pairings: [
      { id: 'minimal-1', displayFont: 'Inter', bodyFont: 'Inter', name: 'Pure Form' },
      { id: 'minimal-2', displayFont: 'DM Sans', bodyFont: 'Work Sans', name: 'Less Is More' },
      { id: 'minimal-3', displayFont: 'Albert Sans', bodyFont: 'Karla', name: 'Whisper' },
      { id: 'minimal-4', displayFont: 'Figtree', bodyFont: 'IBM Plex Sans', name: 'Clear Mind' },
      { id: 'minimal-5', displayFont: 'General Sans', bodyFont: 'Satoshi', name: 'Swiss Grid' },
    ]
  },
  {
    id: 'western-saloon',
    name: 'Western Saloon',
    description: 'Cowboy, rustic, Americana',
    emoji: '🤠',
    pairings: [
      { id: 'western-1', displayFont: 'Rye', bodyFont: 'Bitter', name: 'High Noon' },
      { id: 'western-2', displayFont: 'Ultra', bodyFont: 'Merriweather', name: 'Wanted Poster' },
      { id: 'western-3', displayFont: 'Bree Serif', bodyFont: 'Rokkitt', name: 'Ranch Hand' },
      { id: 'western-4', displayFont: 'Alfa Slab One', bodyFont: 'Josefin Slab', name: 'Gold Rush' },
      { id: 'western-5', displayFont: 'Vast Shadow', bodyFont: 'Sanchez', name: 'Frontier Days' },
    ]
  },
  {
    id: 'art-deco',
    name: 'Art Deco',
    description: '1920s glamour, geometric',
    emoji: '🎭',
    pairings: [
      { id: 'deco-1', displayFont: 'Poiret One', bodyFont: 'Lato', name: 'Gatsby Party' },
      { id: 'deco-2', displayFont: 'Josefin Sans', bodyFont: 'Poppins', name: 'Jazz Age' },
      { id: 'deco-3', displayFont: 'Megrim', bodyFont: 'Raleway', name: 'Chrysler Dreams' },
      { id: 'deco-4', displayFont: 'Oleo Script', bodyFont: 'Open Sans', name: 'Speakeasy' },
      { id: 'deco-5', displayFont: 'Italiana', bodyFont: 'Questrial', name: 'Cinema Club' },
    ]
  },
  {
    id: 'newspaper',
    name: 'Newspaper',
    description: 'Classic journalism, authority',
    emoji: '📜',
    pairings: [
      { id: 'news-1', displayFont: 'Playfair Display', bodyFont: 'Source Serif 4', name: 'Breaking News' },
      { id: 'news-2', displayFont: 'Old Standard TT', bodyFont: 'PT Serif', name: 'Front Page' },
      { id: 'news-3', displayFont: 'Spectral', bodyFont: 'Literata', name: 'Daily Tribune' },
      { id: 'news-4', displayFont: 'Vollkorn', bodyFont: 'Gentium Book Plus', name: 'Evening Post' },
      { id: 'news-5', displayFont: 'Libre Baskerville', bodyFont: 'Charter', name: 'The Chronicle' },
    ]
  },
  {
    id: 'gaming',
    name: 'Gaming',
    description: 'Bold, energetic, esports',
    emoji: '🎮',
    pairings: [
      { id: 'game-1', displayFont: 'Bebas Neue', bodyFont: 'Roboto', name: 'Victory Royale' },
      { id: 'game-2', displayFont: 'Anton', bodyFont: 'Open Sans', name: 'Level Up' },
      { id: 'game-3', displayFont: 'Black Ops One', bodyFont: 'Roboto Condensed', name: 'Warzone' },
      { id: 'game-4', displayFont: 'Teko', bodyFont: 'Barlow', name: 'Speed Run' },
      { id: 'game-5', displayFont: 'Russo One', bodyFont: 'Exo 2', name: 'Boss Battle' },
    ]
  },
  {
    id: 'handwritten',
    name: 'Handwritten',
    description: 'Personal, authentic, casual',
    emoji: '✍️',
    pairings: [
      { id: 'hand-1', displayFont: 'Caveat', bodyFont: 'Nunito', name: 'Dear Diary' },
      { id: 'hand-2', displayFont: 'Patrick Hand', bodyFont: 'Karla', name: 'Sticky Note' },
      { id: 'hand-3', displayFont: 'Kalam', bodyFont: 'Mulish', name: 'Pen Pal' },
      { id: 'hand-4', displayFont: 'Indie Flower', bodyFont: 'Cabin', name: 'Sketchbook' },
      { id: 'hand-5', displayFont: 'Shadows Into Light', bodyFont: 'Hind', name: 'Daydream' },
    ]
  },
  {
    id: 'corporate',
    name: 'Corporate',
    description: 'Professional, trustworthy, B2B',
    emoji: '🏢',
    pairings: [
      { id: 'corp-1', displayFont: 'Montserrat', bodyFont: 'Open Sans', name: 'Annual Report' },
      { id: 'corp-2', displayFont: 'Poppins', bodyFont: 'Lato', name: 'Boardroom' },
      { id: 'corp-3', displayFont: 'Rubik', bodyFont: 'Source Sans 3', name: 'Enterprise' },
      { id: 'corp-4', displayFont: 'Red Hat Display', bodyFont: 'Red Hat Text', name: 'Innovation Hub' },
      { id: 'corp-5', displayFont: 'Plus Jakarta Sans', bodyFont: 'Nunito Sans', name: 'Scale Partners' },
    ]
  },
  {
    id: 'brutalist',
    name: 'Brutalist',
    description: 'Raw, bold, unconventional',
    emoji: '🏗️',
    pairings: [
      { id: 'brutal-1', displayFont: 'Anton', bodyFont: 'IBM Plex Sans', name: 'Concrete Dreams' },
      { id: 'brutal-2', displayFont: 'Bebas Neue', bodyFont: 'Space Grotesk', name: 'Raw Power' },
      { id: 'brutal-3', displayFont: 'Oswald', bodyFont: 'Archivo', name: 'No Frills' },
      { id: 'brutal-4', displayFont: 'Staatliches', bodyFont: 'Work Sans', name: 'Pure Function' },
      { id: 'brutal-5', displayFont: 'League Gothic', bodyFont: 'IBM Plex Mono', name: 'Stripped Down' },
    ]
  },
  {
    id: 'romantic',
    name: 'Romantic',
    description: 'Soft, dreamy, feminine',
    emoji: '💕',
    pairings: [
      { id: 'romantic-1', displayFont: 'Dancing Script', bodyFont: 'Lora', name: 'Love Letters' },
      { id: 'romantic-2', displayFont: 'Parisienne', bodyFont: 'Crimson Pro', name: 'Paris Nights' },
      { id: 'romantic-3', displayFont: 'Allura', bodyFont: 'Cormorant', name: 'Rose Garden' },
      { id: 'romantic-4', displayFont: 'Rouge Script', bodyFont: 'Playfair Display', name: 'Champagne Toast' },
      { id: 'romantic-5', displayFont: 'Petit Formal Script', bodyFont: 'EB Garamond', name: 'Secret Admirer' },
    ]
  },
  {
    id: 'developer-code',
    name: 'Developer/Code',
    description: 'Technical docs, coding blogs',
    emoji: '👨‍💻',
    pairings: [
      { id: 'dev-1', displayFont: 'JetBrains Mono', bodyFont: 'Inter', name: 'Stack Overflow' },
      { id: 'dev-2', displayFont: 'Fira Code', bodyFont: 'Source Sans 3', name: 'GitHub Readme' },
      { id: 'dev-3', displayFont: 'Source Code Pro', bodyFont: 'IBM Plex Sans', name: 'API Docs' },
      { id: 'dev-4', displayFont: 'IBM Plex Mono', bodyFont: 'IBM Plex Sans', name: 'Tech Blog' },
      { id: 'dev-5', displayFont: 'Roboto Mono', bodyFont: 'Roboto', name: 'Terminal Pro' },
    ]
  },
  {
    id: 'vintage-circus',
    name: 'Vintage Circus',
    description: 'Carnival, whimsical, bold',
    emoji: '🎪',
    pairings: [
      { id: 'circus-1', displayFont: 'Alfa Slab One', bodyFont: 'Roboto Slab', name: 'Big Top' },
      { id: 'circus-2', displayFont: 'Passion One', bodyFont: 'Arvo', name: 'Ringmaster' },
      { id: 'circus-3', displayFont: 'Bowlby One SC', bodyFont: 'Bitter', name: 'Sideshow' },
      { id: 'circus-4', displayFont: 'Shrikhand', bodyFont: 'Zilla Slab', name: 'Cotton Candy' },
      { id: 'circus-5', displayFont: 'Lilita One', bodyFont: 'Crete Round', name: 'Fortune Teller' },
    ]
  },
  {
    id: 'nature-organic',
    name: 'Nature/Organic',
    description: 'Earthy, sustainable, wellness',
    emoji: '🌿',
    pairings: [
      { id: 'nature-1', displayFont: 'Cormorant', bodyFont: 'Nunito Sans', name: 'Morning Dew' },
      { id: 'nature-2', displayFont: 'Fraunces', bodyFont: 'Mulish', name: 'Forest Floor' },
      { id: 'nature-3', displayFont: 'Gilda Display', bodyFont: 'Quattrocento Sans', name: 'Herbal Remedy' },
      { id: 'nature-4', displayFont: 'Yeseva One', bodyFont: 'Assistant', name: 'Mountain Air' },
      { id: 'nature-5', displayFont: 'Amatic SC', bodyFont: 'Cabin', name: 'Farmers Market' },
    ]
  },
]

// Helper to get all unique font families from pairings
export function getAllPairingFonts(): string[] {
  const fonts = new Set<string>()
  for (const category of PAIRING_CATEGORIES) {
    for (const pairing of category.pairings) {
      fonts.add(pairing.displayFont)
      fonts.add(pairing.bodyFont)
    }
  }
  return Array.from(fonts)
}

// Helper to get a category by ID
export function getCategoryById(id: string): PairingCategory | undefined {
  return PAIRING_CATEGORIES.find(cat => cat.id === id)
}
